import { useCallback } from "react";
import call from "./call";
import useQuery, { useGetQueryData, useMutateBody } from "./useQuery";
import { useChannelUpdates } from "./ws/useChannelUpdates";

export function useSummaryDashboards(projectId: string) {
  const { body: summaryDashboards } = useQuery("/projects/:projectId(uuid)/summary/dashboards", {
    routeParams: { projectId },
  });
  const getCachedData = useGetQueryData("/projects/:projectId(uuid)/summary/dashboards", {
    routeParams: { projectId },
  });
  const readItems = useCallback(() => getCachedData()?.body, [getCachedData]);
  const fetchUpdatedItems = useCallback(
    (since: string) =>
      call("GET", "/projects/:projectId(uuid)/summary/dashboards/updates/:since(date)", {
        routeParams: { projectId, since: new Date(since) },
      }).then(res => [res.body.summaryDashboards, res.body.deletedSummaryDashboardIds] as const),
    [projectId],
  );
  const mutateItems = useMutateBody("/projects/:projectId(uuid)/summary/dashboards", {
    routeParams: { projectId },
  });

  useChannelUpdates(
    { key: "summary_dashboards", projectId },
    { fetchUpdatedItems, mutateItems, readItems },
  );
  return summaryDashboards;
}

export type SummaryDashboard = ReturnType<typeof useSummaryDashboards>[number];
